export default __webpack_public_path__ + "static/media/settings.8a47b3cb.svg";